import Vue from 'vue'
import VueCustomScroller from 'vue-custom-scrollbar'

Vue.use(VueCustomScroller)
